import { render } from "./PropertyPanel.vue?vue&type=template&id=02c5799c&scoped=true"
import script from "./PropertyPanel.vue?vue&type=script&lang=js"
export * from "./PropertyPanel.vue?vue&type=script&lang=js"

import "./PropertyPanel.vue?vue&type=style&index=0&id=02c5799c&lang=css"
import "./PropertyPanel.vue?vue&type=style&index=1&id=02c5799c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c5799c"]])

export default __exports__